// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2n_hb","left":"styles_left__33aKS"};